/**
 * Web-level route constants shared across the shell (R-SEO-01, R-BRAND-02).
 * Canonical product/brand facts stay in @mist/content; this names the published
 * immutable Official Rules route inventory and navigation.
 */
export const PUBLISHED_RULES = {
  version: '2026-08',
  rulesHash: 'sha256:69f258d73fa6d0a72b4160a298dc8b18d240cab42bf91f2a643114f763cdf4c9',
  canonicalPath: '/official-rules/2026-08',
} as const

export const CURRENT_RULES_VERSION = PUBLISHED_RULES.version

/**
 * Masthead navigation, in the family draft's order: the house pages and the
 * two landing chapters (Collection and Special Editions are hash links into
 * the homepage so they resolve from any route without JavaScript).
 */
export const PRIMARY_NAV = [
  { href: '/', label: 'Home' },
  { href: '/about', label: 'About' },
  { href: '/#collection', label: 'Collection' },
  { href: '/#editions', label: 'Special Editions' },
  { href: '/policies', label: 'Policies' },
  { href: '/contact', label: 'Contact' },
] as const

/** Footer navigation: the edition, archive, and giveaway routes plus the legal cluster. */
export const LEGAL_NAV = [
  { href: '/edition-001/peridot', label: 'Edition 001' },
  { href: '/archive', label: 'The Archive' },
  { href: '/giveaway', label: 'Giveaway' },
  { href: '/privacy', label: 'Privacy' },
  { href: '/terms', label: 'Terms' },
  { href: '/accessibility', label: 'Accessibility' },
  { href: '/contact', label: 'Contact' },
  { href: `/official-rules/${CURRENT_RULES_VERSION}`, label: 'Official Rules' },
] as const
